import { Fancybox } from "@fancyapps/ui";
import { showLoader, hideLoader } from "../../js/modules/loader.js";
import initSubmitForm from "../forms/forms.js";

function cart() {
    initCart();
    toggleMiniCart();
}

function initCart() {
    addToCart();
    handleQuantityChange();
    handleRemoveProduct();
    VyborModif();
}

// Функция для переключения мини-корзины
function toggleMiniCart() {
    const miniCart = document.querySelector(".cart-widget-big");
    miniCart?.querySelectorAll(".cart-widget-big__button, .cart-widget-big__button-continue")
        .forEach(button => button.addEventListener("click", e => {
            e.preventDefault();
            miniCart.classList.toggle('cart-widget-big_sm');
        }));
}

// Асинхронная функция для обновления корзины
async function updateCart() {
    try {
        const response = await fetch(`${window.location.href}#idBasket`);
        const html = await response.text();
        const wrapper = document.createElement('div');
        wrapper.innerHTML = html;
        const cart = wrapper.querySelector('#idBasket');
        document.querySelector('#idBasket_reinit').innerHTML = cart.innerHTML;
        initCart();
    } catch (error) {
        console.error('updateCart error:', error);
    }
}

// Функция для добавления товаров в корзину
async function addToCart() {
    document.querySelectorAll('.button-to-cart').forEach(button => {
        button.addEventListener('click', async (e) => {
            e.preventDefault();
            showLoader();

            const { show_modal_cart, tovar_id, modif_id, class_id = 0 } = button.dataset;
            const count = document.querySelector(`#id_cnt_add_to_cart${tovar_id}`)?.value || 1;

            try {
                const response = await fetch("/classes/ajax/basket/addToBasket.php", {
                    method: "POST",
                    body: JSON.stringify({ tovar_id, modif_id, cnt: count, class_id }),
                    headers: { "Content-Type": "application/json" }
                });
                const html = await response.text();
                await Promise.all([
                    updateProductCount(),
                    updateCartTop(),
                    updateRightCart()
                ]);

                if (getComputedStyle(document.querySelector('.header__mobile')).display === 'none' && show_modal_cart === "1") {
                    try {
                        new Fancybox([{ src: '/json/modal_cart/', type: 'ajax' }]);
                    } catch (error) {
                        console.error('Fancybox cart initialization error:', error);
                    }
                }

                await ecommerceAddProductToCart(button, tovar_id, count);
            } catch (error) {
                console.error('addToCart error:', error);
            } finally {
                hideLoader();
            }
        });
    });
}

// Функция для обновления верхней части корзины
async function updateCartTop() {
    try {
        const response = await fetch("/classes/ajax/basket/action.php", {
            method: "POST",
            body: JSON.stringify({ flag: "changetop" }),
            headers: { "Content-Type": "application/json" }
        });
        const html = await response.text();
        document.querySelector('#basket_top').innerHTML = html;
    } catch (error) {
        console.error('updateCartTop error:', error);
    } finally {
        hideLoader();
    }
}

// Функция для обновления количества товаров
async function updateProductCount() {
    try {
        const response = await fetch("/classes/ajax/basket/action.php", {
            method: "POST",
            body: JSON.stringify({ flag: "change_tovar_cnt" }),
            headers: { "Content-Type": "application/json" }
        });
        const count = await response.text();
        document.querySelectorAll(".ajax_count_tovar").forEach(el => {
            el.textContent = count;
            if (el.classList.contains('count')) {
                el.style.display = count > 0 ? "block" : "none";
            }
        });
    } catch (error) {
        console.error('updateProductCount error:', error);
    }
}

// Функция для обновления правой части корзины
async function updateRightCart() {
    try {
        const response = await fetch("/classes/ajax/basket/action.php", {
            method: "POST",
            body: JSON.stringify({ flag: "show_ajax_right" }),
            headers: { "Content-Type": "application/json" }
        });
        const data = await response.json();

        const cartWidgetBig = document.querySelector('.cart-widget-big');
        if (cartWidgetBig) {
            cartWidgetBig.classList.add('cart-widget-big_active');
            document.querySelector('#right_cart_big_tovar_cnt').textContent = data.cnt;
            document.querySelector('#right_cart_big_tovar_sum').textContent = data.summ;
            cartWidgetBig.classList.remove('cart-widget-big_sm');

            document.querySelector(".cart-widget-big__product").style.display = "block";
            document.querySelector(".cart-widget-big__button-order").style.display = "flex";
            document.querySelector("#right_cart_big_tovar_empty").style.display = "none";
        }

        const cartWidget = document.querySelector('.cart-widget');
        cartWidget?.classList.add('cart-widget_active');

        const cartWidgetBottom = document.querySelector(".cart-widget-bottom");
        if (cartWidgetBottom) {
            cartWidgetBottom.style.display = "flex";
        }
    } catch (error) {
        console.error('RightCart error:', error);
    }
}

// Функция для обработки изменения количества товара
function handleQuantityChange() {
    document.querySelectorAll('.tovar_plus').forEach(button => {
        button.addEventListener('click', async (e) => {
            e.preventDefault();
            showLoader();

            const { tovar_id, m, form_id } = button.dataset;
            let quantity = parseInt(document.querySelector(`#id_tovar_${tovar_id}`).value, 10);
            quantity = m === "plus" ? quantity + 1 : Math.max(1, quantity - 1);

            document.querySelector(`#id_tovar_${tovar_id}`).value = quantity;

            try {
                await fetch("/classes/ajax/basket/action.php", {
                    method: "POST",
                    body: JSON.stringify({ flag: "plusminus", tovar_id, m }),
                    headers: { "Content-Type": "application/json" }
                });
                await Promise.all([
                    updateProductCount(),
                    updateCartTop(),
                    updateRightCart(),
                    updateCart()
                ]);
                setTimeout(() => {
                    initSubmitForm(`form_${form_id}`);
                    hideLoader();
                }, 1500);
            } catch (error) {
                console.error('tovar_plus button handleQuantityChange error:', error);
            }
        });
    });

    document.querySelectorAll('.tovar_counter_list').forEach(button => {
        button.addEventListener('click', (e) => {
            e.preventDefault();
            const { m, tovar_id } = button.dataset;
            const countInput = document.querySelector(`#id_cnt_add_to_cart${tovar_id}`);
            let count = parseInt(countInput.value, 10);
            countInput.value = m === "minus" ? Math.max(1, count - 1) : count + 1;
        });
    });

    document.querySelectorAll('.tovar_change_cnt_manual').forEach(input => {
        input.addEventListener('keyup', async (e) => {
            e.preventDefault();
            const { tovar_id, form_id } = input.dataset;
            const count = input.value;

            showLoader();

            try {
                await fetch("/classes/ajax/basket/action.php", {
                    method: "POST",
                    body: JSON.stringify({ flag: "change_cnt_tovar_manual", tovar_id, cnt: count }),
                    headers: { "Content-Type": "application/json" }
                });
                await Promise.all([
                    updateProductCount(),
                    updateCartTop(),
                    updateRightCart(),
                    updateCart()
                ]);
                setTimeout(() => {
                    initSubmitForm(`form_${form_id}`);
                    hideLoader();
                }, 1500);
            } catch (error) {
                console.error('tovar_change_cnt_manual button handleQuantityChange error:', error);
            }
        });
    });
}

// Функция для удаления товара из корзины
function handleRemoveProduct() {
    document.querySelectorAll(".cart-table__button-del").forEach(button => {
        button.addEventListener("click", async () => {
            if (confirm("Вы действительно хотите удалить товар из корзины?")) {
                const { tovar_id, form_id } = button.dataset;
                const productID = button.closest('tr').dataset.product_id;

                showLoader();

                try {
                    await fetch("/classes/ajax/basket/action.php", {
                        method: "POST",
                        body: JSON.stringify({ flag: "del", tovar_id }),
                        headers: { "Content-Type": "application/json" }
                    });
                    await Promise.all([
                        updateCartTop(),
                        updateCart(),
                        ecommerceDelProductInCart(productID)
                    ]);
                } catch (error) {
                    console.error('handleRemoveProduct error:', error);
                } finally {
                    setTimeout(() => {
                        initSubmitForm(`form_${form_id}`);
                        hideLoader();
                    }, 500);
                }
            }
        });
    });

    const deleteAllButton = document.querySelector(".delete-all");
    deleteAllButton?.addEventListener("click", async () => {
        if (confirm("Вы действительно хотите удалить все товары из корзины?")) {
            try {
                await fetch("/classes/ajax/basket/action.php", {
                    method: "POST",
                    body: JSON.stringify({ flag: "del_all" }),
                    headers: { "Content-Type": "application/json" }
                });
                await Promise.all([
                    updateCartTop(),
                    updateCart()
                ]);
            } catch (error) {
                console.error('handleRemoveProduct deleteAllButton error:', error);
            }
        }
    });
}

// Ecommerce - Добавление товара в корзину
async function ecommerceAddProductToCart(button, tovar_id, count) {
    window.dataLayer = window.dataLayer || [];

    let productID, productName, productPrice, productCategory;

    const productItem = button.closest('.catalog__item, .catalog-list__item, .catalog-list2__item') ||
        document.querySelector('h1');

    if (productItem) {
        productID = tovar_id;
        productName = productItem.querySelector('.catalog__title, .catalog-list__title, .catalog-list2__title')?.textContent ||
            document.querySelector('h1')?.textContent;

        const priceElement = productItem.querySelector('.catalog__price, .catalog-list__price, .catalog-list2__price') ||
            document.querySelector('.product__price');
        productPrice = priceElement ? parseInt(priceElement.textContent.replace(/[^0-9]/gi, ''), 10) : 0;
        productCategory = document.querySelector(`.product-category[data-product-id="${productID}"]`).value;
        // productQuantity = productItem.querySelector('.quantity__input').value;
    }

    dataLayer.push({
        "ecommerce": {
            "currencyCode": "RUB",
            "add": {
                "products": [{
                    "id": productID,
                    "name": productName,
                    "price": productPrice,
                    "category": productCategory,
                    "quantity": count,
                    // "brand": "",
                }]
            }
        }
    });
}

// Ecommerce - Удаление товара из корзины
async function ecommerceDelProductInCart(productID) {
    window.dataLayer = window.dataLayer || [];

    const productRow = document.querySelector(`tr[data-product_id='${productID}']`);
    const productName = productRow.querySelector('.cart-table__name a').textContent;
    const productCategory = document.querySelector(`.product-category[data-product-id="${productID}"]`).value;
    const productQuantity = productRow.querySelector('.quantity__input').value;

    dataLayer.push({
        "ecommerce": {
            "currencyCode": "RUB",
            "remove": {
                "products": [{
                    "id": productID,
                    "name": productName,
                    "category": productCategory,
                    "quantity": productQuantity
                }]
            }
        }
    });
}

async function VyborModif() {
    const modif = document.querySelector(".product__size");
    if(!modif) return false;
    const button_to_cart = document.querySelector(".button-to-cart");
    var price = 0;
    var koprice = 0;
    modif.querySelectorAll('.radio__input').forEach(radio => {
        radio.addEventListener('change', () => {
            //console.log(radio.value);
            button_to_cart.setAttribute('data-modif_id', radio.value);
            price = Number(radio.dataset.price);
            koprice = Number(radio.dataset.koprice);
            document.querySelector('.product__price').innerHTML = price.toLocaleString() + ' ₽';
            document.querySelector('.product__oprice').innerHTML = koprice.toLocaleString() + ' ₽';
        });
    });
}

export default cart;
export {initCart};